export const EVENTS = {
  SITE_VISITED: "site_visited",
  HOME_VIEWED: "home_viewed",

  SEARCH_PERFORMED: "search_performed",
  SEARCH_REPEATED: "search_repeated",
  LISTING_VIEWED: "listing_viewed",

  ADD_TO_CART_CLICKED: "add_to_cart_clicked",
  CART_CREATED: "cart_created",
  CART_UPDATED: "cart_updated",
  CART_IDLE_12H: "cart_idle_12h",
  CART_IDLE_24H: "cart_idle_24h",
  CART_IDLE_36H: "cart_idle_36h",
  CART_ABANDONED: "cart_abandoned",

  SIGNUP_STARTED: "signup_started",
  SIGNUP_COMPLETED: "signup_completed",
  SIGNUP_2FA_FAILED: "signup_2fa_failed",
  LOGIN_SUCCESS: "login_success",
  LOGIN_FAILED: "login_failed",

  BUYER_DASHBOARD_VIEWED: "buyer_dashboard_viewed",
  COLLECTION_ITEM_ADDED: "collection_item_added",
  COLLECTION_VIEWED: "collection_viewed",

  CHECKOUT_STARTED: "checkout_started",
  MULTI_SELLER_CHECKOUT_STARTED: "multi_seller_checkout_started",
  PAYMENT_INITIATED: "payment_initiated",
  PAYMENT_SUCCESS: "payment_success",
  PAYMENT_FAILED: "payment_failed",

  ORDER_CREATED: "order_created",
  ORDER_STATUS_CREATED: "order_status_created",
  ORDER_STATUS_BOOKED: "order_status_booked",
  ORDER_STATUS_COLLECTED: "order_status_collected",
  ORDER_STATUS_DELIVERED: "order_status_delivered",
  ORDER_STATUS_CANCELLED: "order_status_cancelled",
  DELIVERY_CONFIRMED_BY_BUYER: "delivery_confirmed_by_buyer",

  BECOME_SELLER_CLICKED: "become_seller_clicked",
  SELLER_APPLICATION_SUBMITTED: "seller_application_submitted",
  SELLER_APPLICATION_APPROVED: "seller_application_approved",
  SELLER_APPLICATION_REJECTED: "seller_application_rejected",
  SELLER_ROLE_ASSIGNED: "seller_role_assigned",

  SELLER_DASHBOARD_VIEWED: "seller_dashboard_viewed",
  LISTING_CREATED: "listing_created",
  LISTING_APPROVED: "listing_approved",
  LISTING_REJECTED: "listing_rejected",

  SELLER_ORDER_RECEIVED: "seller_order_received",
  SELLER_ORDER_ACCEPTED: "seller_order_accepted",
  SELLER_ORDER_DECLINED: "seller_order_declined",
  SELLER_ORDER_READY_FOR_COLLECTION: "seller_order_ready_for_collection",

  SELLER_RATING_SUBMITTED: "seller_rating_submitted",

  FIRST_SEARCH_PERFORMED: "first_search_performed",
  FIRST_CART_CREATED: "first_cart_created",
  FIRST_ORDER_COMPLETED: "first_order_completed",
  FIRST_COLLECTION_ITEM_ADDED: "first_collection_item_added",
  FIRST_LISTING_PUBLISHED: "first_listing_published",
  FIRST_SALE_COMPLETED: "first_sale_completed",
};
